import React from 'react';
import { rnrUtils } from '@cm/shared-be/cross/index.mjs';

import { labelByKey } from '@cm/new-shared-fe/services/labels';
import { InfoField } from '@cm/react-components';

function uuid (/** string */ prefix) {
  return `${prefix}-${Math.random().toString(36).substr(2, 10)}`;
}

export class InputField extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      id: this.props.id || uuid('input-field_'),
      raisedTitle: false,
      valid: true,
      value: '',
      showValidationError: false,
    };
  }

  handleChange (e) {
    this.setState({ value: e.target.value }, () => {
      this.validateRnr(e.target.value);
    });
  }

  validateRnr (value) {
    const sanitized = value.replace(/\D/g, '');
    const formatted = rnrUtils.formatRnr(sanitized);
    const valid = rnrUtils.validateNRN(sanitized);
    this.setState({
      valid,
      ...((valid || !sanitized) && { value: formatted, showValidationError: false }),
    }, () => {
      this.props.onChange(formatted);
    });
  }

  render () {
    return (
      <div className={'tw-text-field show mt-3 ' + (this.state.raisedTitle && 'focused')}>
        <label className="tw-text-field__label" htmlFor={this.state.id}>{this.props.label}</label>
        <input
          id={this.state.id}
          className={`tw-text-field__input mb-1.5 ${this.state.showValidationError ? 'invalid' : 'valid'}`}
          type="text"
          ref={this.props.inputRef}
          value={this.state.value}
          onFocus={this.handleFocus.bind(this)}
          onBlur={this.handleBlur.bind(this)}
          onChange={this.handleChange.bind(this)}
          data-e2e="national-number-field"
        />
        {this.state.showValidationError && this.state.value
          ? (<InfoField error key={'1'}>{labelByKey('rnr.validation.error.general')}</InfoField>)
          : ''
        }
        {this.props.showRequiredError && !this.state.value
          ? (<InfoField error key={'2'}>{labelByKey('rnr.validation.error.required')}</InfoField>)
          : ''
        }
      </div>
    );
  }

  handleBlur (e) {
    this.setState(state => ({
      ...(!e.target.value && { raisedTitle: false }),
      showValidationError: state.value && !state.valid,
    }));
  }

  handleFocus () {
    this.setState(state => ({
      ...(!state.raisedTitle && { raisedTitle: true }),
    }));
  }
}
